<template>
  <v-app class="bg-login">
    <v-container class="pt-10"
      ><div class="text-center" style="background-color: black">
        <img
          style="width: 100%; max-width: 680px"
          :src="require('@/assets/images/BeautyConnect_logo.png')"
          alt=""
        />
      </div>
      <router-view></router-view>
    </v-container>
  </v-app>
</template>

<script>
export default {};
</script>

<style>
.bg-login > .v-application--wrap {
  background: black;
}
</style>
